export const projects = [
  {
    id: "storepilot",
    title: "Storepilot",
    category: "Retail Management Platform",
    year: "2025",
    description:
      "StockMate's evolution — inventory, billing, payments and cloud sync in one consistent shop-management experience.",
    role: "Product Designer · AI-Assisted Developer",
    tags: ["Mobile App", "Retail Tech", "Business", "SaaS"],
    image: null,
    monogram: "Sp",
    liveUrl: "https://play.google.com/store/apps/details?id=com.dixigen.storepilot",
  },
  {
    id: "stockmate",
    title: "StockMate",
    category: "Offline-first Retail Management",
    year: "2024",
    description:
      "An offline-first inventory and billing app for small retailers — designed in Figma, shipped on Google Play, refined with real users.",
    role: "Product Designer · AI-Assisted Developer",
    tags: ["Mobile App", "Retail Tech", "Business", "Offline-First"],
    image: null,
    monogram: "Sm",
    liveUrl: "https://play.google.com/store/apps/details?id=com.stockmate.app",
  },
  {
    id: "ai-website-builder",
    title: "Brookly AI",
    category: "AI Website Builder · Concept",
    year: "2026",
    description:
      "An AI website builder that starts from a conversation — describe your business, get a tailored website, customise and publish.",
    role: "Product Designer",
    tags: ["AI Product", "Web Design", "Mobile App", "SaaS"],
    image: null,
    monogram: "Bk",
  },
  {
    id: "project-four",
    title: "Project Four",
    category: "Case Study",
    year: "",
    description:
      "Case study in progress. Details about this project will be added soon.",
    role: "",
    tags: [],
    image: null,
    monogram: "04",
  },
];
